import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Task } from '../../../model/task.model';
import { TasksService } from '../../../services/tasks.service';
import { ConnectionStatusService } from 'src/app/services/connection-status.service';
import { StoreService } from 'src/app/services/store.service';
import { MatDialog } from "@angular/material/dialog";
import { CopyTaskDialogComponent } from "../../_dialog/copy-task-dialog/copy-task-dialog.component";
import { ProjectsService } from "../../../../../services/projects.service";
import { CopyFormDialogData } from "../../../model/form.model";
import { DialogService } from 'src/app/services/dialog.service';
import { TaskAssigneesDialogComponent } from '../../../pages/tasks-page/components/task-assignees-dialog/task-assignees-dialog.component';
import { SyncProgressDialogComponent } from '../../_dialog/sync-progress-dialog/sync-progress-dialog.component';
import { SessionService } from 'src/app/services/session.service';
import { filter, from, switchMap, tap } from 'rxjs';

@Component({
  selector: 'tasks-grid-actions',
  templateUrl: './tasks-grid-actions.component.html',
})
export class TasksGridActionsComponent implements ICellRendererAngularComp {
  cellValue!: Task;
  params!: ICellRendererParams;
  canDownloadZip = false;

  constructor(
    private tasksService: TasksService,
    public store: StoreService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private projectsService: ProjectsService,
    public connectionStatusService: ConnectionStatusService,
    private sessionService: SessionService
  ) {}
  refresh(params: ICellRendererParams): boolean {
    this.cellValue = params.data;
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.params = params;
    this.cellValue = params.data;
  }

  isSyncButtonDisabled(isOnline: boolean | null): boolean {
    return !(
      this.cellValue.localVersion &&
      !!isOnline &&
      this.cellValue.assignedTo?.id === this.store.loggedUser.id
    );
  }

  synchronizeTask(event: MouseEvent) {
    event.stopPropagation();
    from(this.sessionService.refreshSessionForSync()).pipe(
      filter((isRefreshed) => isRefreshed),
      tap(() => this.dialog.open(SyncProgressDialogComponent, {
        disableClose: true,
        closeOnNavigation: false,
        hasBackdrop: true,
        panelClass: 'sync-progress-fullscreen-dialog'
      })),
      switchMap(() => this.tasksService.runSyncTaskWithProgress(this.cellValue.id))
    )
      .subscribe();
  }

  copyTask(event: MouseEvent) {
    event.stopPropagation();
    this.store.showLoader();
    this.store.hideLoader();
    this.dialog.open<CopyTaskDialogComponent, CopyFormDialogData>(
      CopyTaskDialogComponent,
      {
        data: {
          task: this.cellValue
        },
      }
    );
  }

  assignToUser(event: MouseEvent) {
    event.stopPropagation();

    if (this.cellValue.assignees.length === 0) {
      this.dialogService.showInfoDialog({
        content: 'ORDERS.NO_AVAILABLE_INSPECTORS',
        header: 'ORDER',
        hideCancelBtn: true,
        confirmBtn: 'OK',
      });
      return;
    }

    this.dialog.open(TaskAssigneesDialogComponent, {
      data: {
        currentUser: this.cellValue.assignedTo,
        taskId: this.cellValue.id,
        users: this.cellValue.assignees.sort((a, b) => {
          return (a.department ?? '').localeCompare(b.department || '') ||  a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName);
        })
      }
    });
  }
}
